var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "music") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "nc-icon-wrapper",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    fill: "#de6139",
    stroke: "#de6139"
  }, /*#__PURE__*/React.createElement("line", {
    "data-color": "color-2",
    fill: "none",
    strokeMiterlimit: 10,
    x1: 8,
    y1: 7,
    x2: 23,
    y2: 7
  }), /*#__PURE__*/React.createElement("polyline", {
    "data-cap": "butt",
    fill: "none",
    stroke: "#de6139",
    strokeMiterlimit: 10,
    points: "23,17.5 23,1 8,1 8,19.5 "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#de6139",
    strokeMiterlimit: 10,
    cx: 4.5,
    cy: 19.5,
    r: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    stroke: "#de6139",
    strokeMiterlimit: 10,
    cx: 19.5,
    cy: 17.5,
    r: 3.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.83b83286.svg";
export { ForwardRef as ReactComponent };